import Reveal, { SectionHead } from "@/components/Reveal";

const path = [
  {
    years: "Inferiores",
    club: "Cantera Colo-Colo",
    desc: "Formado en las divisiones menores del Cacique, creciendo dentro de la identidad del club más grande de Chile.",
    tags: ["Colo-Colo", "Formativas"],
  },
  {
    years: "2025",
    club: "Mundial Sub-17 FIFA",
    desc: "Convocado por la Selección Chilena para disputar la Copa Mundial Sub-17 de la FIFA Qatar 2025.",
    tags: ["La Roja Sub-17", "Qatar 2025"],
  },
  {
    years: "Ago 2026",
    club: "Debut Profesional",
    desc: "Estreno en el fútbol profesional con la camiseta N°42 de Colo-Colo.",
    tags: ["Primera División", "N°42"],
  },
  {
    years: "Sep 2026",
    club: "Primera Titularidad",
    desc: "Titular frente a Audax Italiano por Copa Chile, su primera vez desde el inicio en el profesionalismo.",
    tags: ["Copa Chile", "Titular"],
  },
];

export default function Trayectoria() {
  return (
    <section id="trayectoria" data-testid="trayectoria-section" className="relative py-28 px-6 border-t border-neutral-900">
      <div className="max-w-4xl mx-auto">
        <SectionHead eyebrow="03 — Trayectoria" title="De la cantera al mundo" testId="trayectoria-title" />

        <div className="mt-16 relative">
          <div className="absolute left-[7px] top-2 bottom-2 w-px bg-neutral-800" aria-hidden="true" />
          <div className="space-y-14">
            {path.map((step, i) => (
              <Reveal key={step.club} delay={i * 0.08} className="relative pl-12">
                <span className="absolute left-0 top-2 w-[15px] h-[15px] bg-[#050505] border-2 border-[#d4af37] rotate-45" aria-hidden="true" />
                <p className="font-tech text-xs uppercase tracking-[0.3em] text-[#d4af37]">{step.years}</p>
                <h3 className="font-display text-2xl sm:text-3xl font-extrabold uppercase mt-2" data-testid={`trayectoria-club-${i}`}>
                  {step.club}
                </h3>
                <p className="text-base text-neutral-400 leading-relaxed mt-3 max-w-xl">{step.desc}</p>
                <div className="flex flex-wrap gap-2 mt-4">
                  {step.tags.map((t) => (
                    <span key={t} className="font-tech text-[10px] uppercase tracking-widest border border-neutral-800 bg-[#0f0f0f] px-3 py-1.5 text-neutral-400">
                      {t}
                    </span>
                  ))}
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
